import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('ctrlModulos', ['moduloAtivo'])
  },

  watch: {
    moduloAtivo(newValue, oldValue) {

      if (oldValue !== undefined && newValue !== oldValue) {        
        if (typeof this.reloadData === 'function') {
          this.reloadData();
        } else {
          console.warn(
            '[Module Reload Mixin] Component does not implement reloadData() method.',
            'Please add a reloadData() method to reload your page data.'
          );
        }
      }
    }
  }
};
